import React from "react";
import { Col } from "reactstrap";
import DashPanel from "../common/DashPanel";
import SectionTitle from "../common/SectionTitle";
import StatBadgeRow from "../common/StatBadgeRow";
import ProgressRow from "../common/ProgressRow";
import { fmtINR, fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";
import { purchaseData } from "../../data/dashboardMockData";

const MODULE_COLORS = [T.blue, T.green, T.orange, T.purple, T.teal];

const PurchaseSection = ({ loading }) => (
  <Col xl={6} className="d-flex">
    <DashPanel
      title="Purchase Orders"
      icon="bx bx-cart-alt"
      iconColor={T.orange}
      loading={loading}
    >
      <StatBadgeRow
        items={[
          { label: "Total Orders", value: fmtNum(purchaseData.totalOrders), color: T.blue },
          { label: "Pending", value: fmtNum(purchaseData.pendingOrders), color: T.yellow },
          { label: "Approved", value: fmtNum(purchaseData.approvedOrders), color: T.green },
          { label: "Rejected", value: fmtNum(purchaseData.rejectedOrders), color: T.red },
        ]}
        loading={loading}
      />

      <SectionTitle>Orders by Module</SectionTitle>
      {purchaseData.modules.map((m, i) => (
        <ProgressRow
          key={i}
          label={m.module}
          value={fmtNum(m.orders)}
          max={purchaseData.totalOrders || 1}
          rawValue={m.orders}
          color={MODULE_COLORS[i % 5]}
          badge={fmtINR(m.amount)}
          loading={loading}
        />
      ))}
    </DashPanel>
  </Col>
);

export default PurchaseSection;
